import Glide from '@glidejs/glide';
import {ReadyProvider} from '../providers/readyProvider';

class SmallSlider
{
    /**
     * @param {String} selector
     */
    static init(selector) {
        if (!document.querySelector(selector)) {
            return;
        }

        new Glide(selector, {
            type: 'slider',
            startAt: 0,
            perView: 1,
            bound: true,
        }).mount();
    }
}

ReadyProvider.executeOnReady(() => SmallSlider.init('[data-block="slider"][data-type="small"]'));
